'use client'

import Image from 'next/image'
import { FC, useState } from 'react'

interface ImageWithFallbackProps {
  src?: string
  alt: string
  width?: number
  height?: number
  fallbackSrc: string
  className?: string
  priority?: boolean
  fill?: boolean
  sizes?: string
}

const ImageWithFallback: FC<ImageWithFallbackProps> = (props) => {
  const { src, alt, fallbackSrc, className, width, height, priority, fill, sizes } = props
  const [currentSrc, setCurrentSrc] = useState(src)

  const handleError = () => {
    setCurrentSrc(fallbackSrc!)
  }

  return (
    <Image
      src={currentSrc ?? fallbackSrc}
      alt={alt}
      className={className}
      onErrorCapture={handleError}
      onEmptied={handleError}
      defaultValue={fallbackSrc}
      height={height}
      width={width}
      fill={fill}
      sizes={sizes}
      priority={priority}
    />
  )
}

export default ImageWithFallback
